export default {
    methods: {
        createBreadcrumbsForFolder(folder){
            const breadCrumbs = [folder];
            let currentFolder = folder;

            //Take everything starting from the current node
            //everything up until the root node can be used for breadcrumbs
            while (!!currentFolder.parent){
                currentFolder = currentFolder.parent;
                breadCrumbs.unshift(currentFolder);
            }

            return breadCrumbs;
        }
    }
};